import {isDevMode} from "@angular/core";

const levelOrder = ['trace', 'debug', 'info', 'warn', 'error', 'none'] as const;
type LogLevel = (typeof levelOrder)[number];

export class Logger {
  private readonly level: LogLevel;

  constructor() {
    this.level = isDevMode() ? 'debug' : 'info';
  }

  private shouldLog(level: LogLevel): boolean {
    return levelOrder.indexOf(level) >= levelOrder.indexOf(this.level);
  }

  public trace(...args: any[]): void {
    if (this.shouldLog('trace')) {
      console.trace(...args);
    }
  }

  public debug(...args: any[]): void {
    if (this.shouldLog('debug')) {
      console.debug(...args);
    }
  }

  public info(...args: any[]): void {
    if (this.shouldLog('info')) {
      console.info(...args);
    }
  }

  public warn(...args: any[]): void {
    if (this.shouldLog('warn')) {
      console.warn(...args);
    }
  }

  public error(...args: any[]): void {
    if (this.shouldLog('error')) {
      console.error(...args);
    }
  }
}
